import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import type { TournamentEventsPage } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The tournament's PUBLIC events list (GET /tournaments/{id}/events →
 * {items, total, page, page_size}, anonymous-readable). This is a SEPARATE
 * query from the main detail fetch, with its OWN loading/error — so the Events
 * section is isolated: a failing events fetch surfaces the section's own
 * role="alert" while the main detail (name / schedule) still renders. The page
 * renders the server's order verbatim — no client re-sort, no derived counts.
 */
export function useTournamentEvents(tournamentId: string | undefined) {
  return useQuery<TournamentEventsPage>({
    queryKey: queryKeys.tournaments.events(tournamentId ?? ""),
    queryFn: () => tournamentApi.listEvents(tournamentId as string),
    enabled: Boolean(tournamentId),
  });
}
